<div class="loader">
  <!-- <img src="../../../assets/icons/loader22.gif" alt="" /> -->
</div>
